import type { BrowseAgentCategory } from '../types';

export const getCategoryById = (
	categories: readonly BrowseAgentCategory[],
	categoryId?: string,
): BrowseAgentCategory => categories.find(({ id }) => id === categoryId) ?? categories[0];
